import { createContextHook } from '@/utils';
import { ConfettiContext } from './ConfettiContext';

export const useConfetti = createContextHook(ConfettiContext);
